module.exports = __webpack_public_path__ + "img/pricing.12693f71.svg";